import type { ContextoDaAcao } from '../dominio/contextoDaAcao'

export interface MensagemDeModuloParaOAssistente {
  texto: string
  contextoDaAcao: ContextoDaAcao
}

export type DespachanteDeAcaoDeModulo = (mensagem: MensagemDeModuloParaOAssistente) => boolean

let despachante: DespachanteDeAcaoDeModulo | null = null

export function registrarDespachanteDeAcoesDosModulos (
  novoDespachante: DespachanteDeAcaoDeModulo
): () => void {
  despachante = novoDespachante
  return () => {
    if (despachante === novoDespachante) despachante = null
  }
}

export function despacharAcaoDeModuloParaOAssistente (
  mensagem: MensagemDeModuloParaOAssistente
): boolean {
  return despachante?.(mensagem) === true
}
